import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { useSelector, useDispatch } from 'react-redux';
import { selectCurrentTool, setCurrentTool } from '../features/currentTool/currentToolSlice';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import SidebarHome from '../components/SidebarHome';
import ChatComponent from '../components/ChatComponent';
import NFTChatComponent from '../components/NFTChatComponent';
import { close } from '../features/mobile/menuSlice';
import { faCircleInfo } from '@fortawesome/free-solid-svg-icons';
import config from '../config/config';
import ToolsModal from '../components/ToolsModal';
import { openToolsModal } from '../features/tools/toolsModalSlice';
import { faStar as solidStar } from '@fortawesome/free-solid-svg-icons';
import { faStar as regularStar } from '@fortawesome/free-regular-svg-icons';
import { setUser, selectUser } from '../features/user/userSlice';
import { addToast } from '../features/ui/uiSlice';
import axios from 'axios';
import { showModal } from '../features/ui/uiSlice';
import SidebarHistory from '../components/SidebarHistory';

const apiURL = config.apiUrl;

function Home() {
  const dispatch = useDispatch();
  const user = useSelector(selectUser);
  const fetchedTools = useSelector((state) => state.tools.items);
  const currentTool = useSelector(selectCurrentTool);
  if (!currentTool && fetchedTools?.length > 0) {
    dispatch(setCurrentTool(fetchedTools[0]));
  }
  const [isFavorite, setIsFavorite] = useState(
    user.favorites?.generators?.includes(currentTool?._id)
  );

  useEffect(() => {
      setIsFavorite(user.favorites?.generators?.includes(currentTool?._id));
  }, [user, currentTool]);

  const toggleFavorite = async () => {
    let updatedFavorites;
    const newFavoriteStatus = !isFavorite;
    setIsFavorite(newFavoriteStatus);
    try {
        await axios.post(`${apiURL}/favorites/update`, {
            dynamic_id: user.dynamic_id,
            item_id: currentTool._id,
            type: 'generators',
            isFavorite: newFavoriteStatus,
        });
        dispatch(addToast(newFavoriteStatus ? 'Favorite Added!' : 'Favorite Removed!', 'success'));

        if (newFavoriteStatus) {
            updatedFavorites = {
                ...user.favorites,
                ['generators']: [...user.favorites['generators'], currentTool._id],
            };

        } else {
            updatedFavorites = {
                ...user.favorites,
                ['generators']: user.favorites['generators'].filter((id) => id !== currentTool._id),
            };
        }
        const updatedUser = {
            ...user,
            favorites: updatedFavorites,
        };
        dispatch(setUser(updatedUser));
      } catch (error) {
        setIsFavorite(!newFavoriteStatus);
        dispatch(addToast('Favorite NOT updated! Please try again.', 'error'));
      }
  };

  const [selectedSidebar, setSelectedSidebar] = useState('menu');

  const toggleSidebar = (option) => {
    setSelectedSidebar(option);
  };

  if (fetchedTools.length === 0 || !fetchedTools.tools.length > 0 || !fetchedTools.assistants > 0) return <span>Loading...</span>;

  return (
    <>
      <Helmet>
        <title>{config.siteTitle}</title>
        <meta name="description" content={config.siteDescription} />
        <meta name="keywords" content={config.siteKeywords} />
        <link rel="icon" type="image/png" href={config.favicon} />
        <link rel="canonical" href={config.app_url} />
        <meta property="og:title" content={config.siteTitle} />
        <meta property="og:description" content={config.siteDescription} />
        <meta property="og:image" content={config.favicon} />
        <meta property="og:url" content={config.app_url} />
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content={config.siteName} />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={config.siteTitle} />
        <meta name="twitter:description" content={config.siteDescription} />
        <meta name="twitter:image" content={config.favicon} />
        <meta name="twitter:site" content={config.twitter} />
        <meta name="twitter:creator" content={config.twitter} />
      </Helmet>
      <div className='flex flex-col min-w-0 md:flex-row w-full gap-2 h-95vh lg:pr-4'>
        
        <div className={`fixed inset-0 z-10 p-4 pt-1 hidden xl:relative xl:flex xl:flex-col xl:w-1/6 xl:min-w-fit xl:rounded xl:mx-auto border border-primary`}>
          <div className='flex flex-row gap-2 mb-2'>
            <button onClick={() => toggleSidebar('menu')} className={`p-1 w-1/2 text-center border border-primary rounded ${selectedSidebar === 'menu' ? 'bg-primary text-gray-200' : 'bg-body text-primary'}`}>Menu</button>
            <button onClick={() => toggleSidebar('history')} className={`p-1 w-1/2 text-center border border-primary rounded ${selectedSidebar === 'history' ? 'bg-primary text-gray-200' : 'bg-body text-primary'}`}>History</button>
          </div>
          {selectedSidebar === 'menu' && <SidebarHome />}
          {selectedSidebar === 'history' && <SidebarHistory />}
        </div>
        
        <div className="xl:hidden flex-grow min-w-0">
          <div className='flex flex-row items-center justify-center gap-2'>
            <button onClick={toggleFavorite} className="p-1 rounded border border-primary w-1/5 mb-2 hover:bg-gray-700 hover:text-gray-200">
                <FontAwesomeIcon icon={isFavorite ? solidStar : regularStar} className="text-yellow-400"/>
            </button>
            <button onClick={() => dispatch(showModal(currentTool.description))} className="p-1 rounded border border-primary w-1/5 mb-2 hover:bg-gray-700 hover:text-gray-200">
                <FontAwesomeIcon icon={faCircleInfo} className=""/>
            </button>
            <Link to={`/`} className="text-poetsen w-3/5 justify-center flex items-center px-1 py-1 border border-primary hover:bg-gray-700 hover:text-gray-200 focus:outline-none rounded mb-2" onClick={() => {dispatch(openToolsModal()); dispatch(close());}}>
                View All Tools
            </Link>
          </div>
          {currentTool?._id === '66365d3efec2b358df7f572a' ? <NFTChatComponent /> : <ChatComponent />}
          {/*<ChatComponent />*/}
        </div>
        <div className="hidden xl:flex flex-grow min-w-0">
          {currentTool?._id === '66365d3efec2b358df7f572a' ? <NFTChatComponent /> : <ChatComponent />}
          {/*<ChatComponent />*/}
        </div>
      </div>
      <ToolsModal />
    </>
  );
}

export default Home;

